<template>
	<div class="tech">
		<div class="view-header">
			<img class="view-header__image" src="@/assets/foo-tech-3.png">
			<h1 class="title">
				Nuestra Tecnología <span class="text--highlighted">&lt;/&gt;</span>
			</h1>
			<p class="view-header__description">
				Desarrollamos productos que mejoran el trabajo de nuestros Clientes
			</p>
		</div>
		<!-- content -->
		<section-handler :sections="sections"></section-handler>
	</div>
</template>

<script>
	import content from "@/content.json";
	import sectionHandler from "@/components/SectionHandler";

	export default {
		name: "Tech",
		components: {
			sectionHandler
		},
		data() {
			return {
				sections: content.tech
			}
		}
	}
</script>